import * as types from '../actionTypes';

export const onGoogleMapsApiLoaded = () => ({
  type: types.GOOGLE_MAPS_API_LOADED,
});

export const onPlacesAutocompleteBinded = () => ({
  type: types.PLACES_AUTOCOMPLETE_BINDED,
});
